export default function Camera({
  color,
  w = 14,
  h = w,
  className,
}: {
  color: string;
  w?: number | string;
  h?: number | string;
  className?: string;
}) {
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ?? ""}
    >
      <path
        d="M9.1875 5.77865C9.1875 6.36811 8.95703 6.93342 8.5468 7.35023C8.13656 7.76704 7.58016 8.0012 7 8.0012C6.41984 8.0012 5.86344 7.76704 5.4532 7.35023C5.04297 6.93342 4.8125 6.36811 4.8125 5.77865C4.8125 5.18919 5.04297 4.62387 5.4532 4.20706C5.86344 3.79025 6.41984 3.55609 7 3.55609C7.58016 3.55609 8.13656 3.79025 8.5468 4.20706C8.95703 4.62387 9.1875 5.18919 9.1875 5.77865Z"
        fill={color}
      />
      <path
        d="M1.75 1.77805C1.28587 1.77805 0.840752 1.96537 0.512563 2.29882C0.184374 2.63227 0 3.08452 0 3.55609L0 8.89023C0 9.36179 0.184374 9.81404 0.512563 10.1475C0.840752 10.4809 1.28587 10.6683 1.75 10.6683H12.25C12.7141 10.6683 13.1592 10.4809 13.4874 10.1475C13.8156 9.81404 14 9.36179 14 8.89023V3.55609C14 3.08452 13.8156 2.63227 13.4874 2.29882C13.1592 1.96537 12.7141 1.77805 12.25 1.77805H11.2245C10.7604 1.77794 10.3154 1.59055 9.98725 1.25708L9.26275 0.520967C8.93464 0.187496 8.48959 0.000100704 8.0255 0H5.9745C5.51041 0.000100704 5.06536 0.187496 4.73725 0.520967L4.01275 1.25708C3.68464 1.59055 3.23959 1.77794 2.7755 1.77805H1.75ZM2.1875 3.55609C2.07147 3.55609 1.96019 3.50926 1.87814 3.4259C1.79609 3.34253 1.75 3.22947 1.75 3.11158C1.75 2.99369 1.79609 2.88062 1.87814 2.79726C1.96019 2.7139 2.07147 2.66707 2.1875 2.66707C2.30353 2.66707 2.41481 2.7139 2.49686 2.79726C2.57891 2.88062 2.625 2.99369 2.625 3.11158C2.625 3.22947 2.57891 3.34253 2.49686 3.4259C2.41481 3.50926 2.30353 3.55609 2.1875 3.55609ZM10.0625 5.77865C10.0625 6.60389 9.73984 7.39533 9.16551 7.97886C8.59118 8.5624 7.81223 8.89023 7 8.89023C6.18777 8.89023 5.40882 8.5624 4.83449 7.97886C4.26016 7.39533 3.9375 6.60389 3.9375 5.77865C3.9375 4.9534 4.26016 4.16196 4.83449 3.57843C5.40882 2.99489 6.18777 2.66707 7 2.66707C7.81223 2.66707 8.59118 2.99489 9.16551 3.57843C9.73984 4.16196 10.0625 4.9534 10.0625 5.77865Z"
        fill={color}
      />
    </svg>
  );
}
